<template>
    <div>
        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+phase.id" :endpoint-params="endpointParams" 
            :custom-class="customClass" :props="props" :map="map" :bus="bus"
            :title2="registration.program.name" description-toggle="1" description-hidden="1"
            :link1="group" :link2="location"
            :user-name="userName" :user-picture="userPicture">
        </trax-ui-top-box>
    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-atpl-dashboard-phase-custom-top-box'},
            groupLink: { default: false },
            customizeButton: null,
            topButtons: null,
            displayLearner: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                aggregation_dashboard_routes: data.aggregation_dashboard_routes,
                endpoint: app_url+'polaris/api/front/phases',
                endpointParams: {
                    relations: ['location'],
                    options: { registration: data.registration.id }
                },
                props: {
                    name: { source:'name' },
                    description: {source: 'description'},
                    custom: {source: 'custom'},
                    location: {source: 'location'},
                    background: {source: 'meta.background'}
                },
                map: {
                    title1: 'name',
                    descriptionTitle: this.hdvRef,
                    description: 'description',
                    backgroundImage: 'background'
                },
                bus: new Vue()
            }
        },

        computed: {

            customClass: function() {
                return this.topButtons ? 'mb-1' : '';
            },

            userName: function() {
                if (!this.displayLearner || !this.learner) return null;
                return this.learner.lastname + ' ' + this.learner.firstname;
            },

            userPicture: function() {
                if (!this.displayLearner || !this.learner) return null;
                return this.learner.avatar;
            },

            group: function() {
                var link = {value: this.registration.cohort.name, icon: 'people'};
                var routes = this.aggregation_dashboard_routes;
                var href = routes[this.phase.type]+'/registration/'+this.registration.id+'/'+this.phase.type+'/'+this.phase.id;
                if (this.collectiveDashboardPermission && this.groupLink) link.href = href;
                return link;
            },

            collectiveDashboardPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-mine-collaborators'] || this.user.permissions['dashboard.write-all']
                    || this.user.permissions['dashboard.write-mine-locations'] || this.user.permissions['registration.manage'];
            },
        },

        methods: {

            hdvRef: function(data) {
                if (!data.custom || !data.custom.meta.hdv_ref) return null;
                return 'HDV: ' + data.custom.meta.hdv_ref;
            },

            location: function(data) {
                if (data.custom && data.custom.location) {
                    return {value: data.custom.location.name, icon: 'location_on'};
                }
                if (data.location) {
                    return {value: data.location.name, icon: 'location_on'};
                }
                return null
            },
        }
    }
</script>
